module.exports = __webpack_public_path__ + "adaa3411c2119cedb7d5d2735670b57f.png";